import { Component, OnInit } from '@angular/core';
import {UntypedFormBuilder, UntypedFormControl, UntypedFormGroup} from '@angular/forms';
import {EntityAccessModel} from '../../../../DataModels/entity-access-model';
import {DataService} from '../../../../Services/data.service';
import {ActivatedRoute, Router} from '@angular/router';
import {HttpErrorResponse} from '@angular/common/http';
import {SysUserModel} from '../../../../DataModels/sys-user-model';
import {EntityModel} from '../../../../DataModels/entity-model';
import {ConfirmDialogService} from '../../../../Services/confirm-dialog.service';
import { BsToastService} from '../../../../Services/bs-toast-service';
import {Title} from '@angular/platform-browser';

@Component({
  selector: 'app-entity-access-form',
  templateUrl: './entity-access-form.component.html',
  styleUrls: ['./entity-access-form.component.css'],
  standalone: false
})
export class EntityAccessFormComponent implements OnInit {
  buttonConfig: any = {
    save: true,
    close: true,
    reset: true,
    delete: true,
    saveNew: true,
    saveClose: true,
    print: false,
  };

  entityAccessID;
  private entityAccess: EntityAccessModel;
  entityAccessForm: UntypedFormGroup;

  users: SysUserModel[] = [];
  entities: EntityModel[] = [];

  batchlocked = 0;

  paid = false;
  showDelete = false;
  submitted = false;
  isSaveNew = false;
  originalSnapshot: any = {};

  constructor(private table: DataService,
              private notification: BsToastService,
              private formBuilder: UntypedFormBuilder,
              private route: ActivatedRoute,
              private router: Router,
              private confirmDialogService: ConfirmDialogService,
              private titleService: Title) {
    this.createForm();
    this.entityAccessID = this.route.snapshot.params.id;
  }

  get f() {
    return this.entityAccessForm.controls;
  }

  createForm() {
    this.entityAccessForm = this.formBuilder.group({
      user_id: new UntypedFormControl(''),
      entity_id: new UntypedFormControl(''),
    });
  }
  ngOnInit() {
    this.loadLookups();
    if (this.entityAccessID) {
      this.LoadData();
      this.titleService.setTitle($localize`:Entity Access @@entityAccess:Entity Access`);
      this.buttonConfig.reset = false;
    } else {
      Promise.resolve().then(() => {
        try {
          this.originalSnapshot = this.buildSnapshot();
        } catch {
        }
      });
    }
  }

  private LoadData() {
    this.table.getData('EntityAccess', this.entityAccessID).subscribe({
      next: (result: any) => {
        const data = (result && result.Data !== undefined) ? result.Data : result;
        this.entityAccess = data as EntityAccessModel;
        this.entityAccessForm.patchValue(this.entityAccess);
        try {
          this.originalSnapshot = this.buildSnapshot();
        } catch {
        }
      },
      error: (error: HttpErrorResponse) => {
        // this.notification.error($localize`:Error loading Entity Access @@errorLoadingEntityAccess:Error loading Entity Access`);
        console.log(error + ' - ' + $localize`:Error loading Entity Access @@errorLoadingEntityAccess:Error loading Entity Access`);
      }
    });
  }

  private loadLookups(){
    this.table.getApiListData('entity', '?state=active&pageNumber=0&pageSize=999999').subscribe((res: any) => {
      const data: any = res?.Data ?? res;
      this.entities = data as EntityModel[];
    });
    this.table.getApiListData('sys_user', '?state=active&pageNumber=0&pageSize=999999').subscribe((res: any) => {
      const data: any = res?.Data ?? res;
      this.users = data as SysUserModel[];
    });
  }

  saveClose() {
    if (this.onSave(true)) {
    }
  }

  saveNew() {
    this.isSaveNew = true;
    this.onSave(false);
  }

  resetForm() {
    this.resetToDefaults();
    try {
      this.originalSnapshot = this.buildSnapshot();
    } catch {
    }
  }

  private resetToDefaults(): void {
    // Explicitly reset form fields and component state
    this.entityAccessForm.reset({
      user_id: '',
      entity_id: ''
    });
    this.entityAccessID = null;
    this.entityAccess = {} as EntityAccessModel;
    this.submitted = false;
    try {
      this.originalSnapshot = this.buildSnapshot();
    } catch {
    }
  }

   onClose() {
    this.router.navigate(['admin/entity-access-list']).then();
  }

  deleteItem() {
    let retMsg = '';
    const messages: string[] = [$localize`:Are you sure you want to delete entity access? @@areYouSureYouWantToDeleteEntityAccess:Are you sure you want to delete entity access?`, this.entityAccess.entity_id];
    this.confirmDialogService.confirmThis(
      messages,
      () => {
        this.table.deleteDataById('EntityAccess', this.entityAccessID).subscribe(
          (result) => {
            retMsg = result;
            // this.notification.success($localize`:Deleted @@deleted:Deleted`);
          },
          (error: HttpErrorResponse) => {
            // this.notification.error($localize`:Error @@error:Error`);
            console.log(error);
          },
          () => {
            this.onClose();
          }
        );
      },
      () => {
        this.notification.showSuccessToast($localize`:Delete Canceled @@deleteCanceled:Delete Canceled`);
      }
    );
  }

  onSave(saveClose: boolean) {
    this.submitted = true;
    if (this.entityAccessForm.invalid) {
      this.notification.showWarningToast($localize`:Form Errors! @@formErrors:Form Errors!`);
      return;
    }
    this.entityAccess = Object.assign({}, this.entityAccessForm.value);
    if (this.entityAccessID) {
      if (this.entityAccessForm.invalid === false) {
        this.table
          .patch('EntityAccess', this.entityAccessID, this.entityAccess)
          .then(
            () => {
              try {
                this.originalSnapshot = this.buildSnapshot();
              } catch {
              }
              if (saveClose) {
                this.onClose();
              } else if (this.isSaveNew) {
                this.resetToDefaults();
                this.isSaveNew = false;
              }
            },
            (error: HttpErrorResponse) => {
              console.log(error);
            }
          )
          .finally(() => {
            this.submitted = false;
          });
      }
    } else {
      this.table
        .postWithPromise('EntityAccess', this.entityAccess)
        .then(
          (res) => {
            // stops double posting when clicking Save
            let apiReturn: any = null;
            if (typeof res === 'object') {
              apiReturn = JSON.parse(JSON.stringify(res));
            }
            this.entityAccessID = apiReturn?.id;
            try {
              this.originalSnapshot = this.buildSnapshot();
            } catch {
            }
            if (saveClose) {
              this.onClose();
            } else if (this.isSaveNew) {
              this.resetToDefaults();
              this.isSaveNew = false;
            }
          },
          (error: HttpErrorResponse) => {
            console.log(error);
          }
        )
        .finally(() => {
          this.submitted = false;
        });
    }
    return true;
  }

  buildSnapshot(): any {
    try {
      return this.entityAccessForm.getRawValue();
    } catch {
      return {};
    }
  }

  hasChanges(): boolean {
    try {
      const current = this.buildSnapshot();
      const original = this.originalSnapshot || {};
      return JSON.stringify(current) !== JSON.stringify(original);
    } catch {
      return false;
    }
  }

  checkForChanges(): boolean {
    return this.hasChanges();
  }
}
